module.exports = __webpack_public_path__ + "img/carrousel-rad-con-arco-zen-2.64194315.png";